var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-button-field',{attrs:{"title":_vm.$t('settings.liveReporting.field'),"is-empty":_vm.isValueEmpty,"addable":"","removable":""},on:{"create":_vm.showEditLiveReportingModal,"edit":_vm.showEditLiveReportingModal,"delete":_vm.removeLiveReporting}})
}
var staticRenderFns = []

export { render, staticRenderFns }